<template>
  <div class="container">
    <div class="title">{{ agreement.title }}</div>
    <div
      class="contenn"
      v-html="agreement.content"
      style="font-size: 14px"
    ></div>
    <div class="cancel" @click="goBack">返回</div>
  </div>
</template>

<script>
import { $get_agreement } from "@/api";
export default {
  name: "feedbackFile",
  props: {},
  data() {
    return {
      agreement: {}, // 协议
    };
  },
  components: {},
  created() {},
  async mounted() {
    try {
      let res = await $get_agreement({ id: this.$route.query.id });
      this.agreement = res.data;
    } catch (error) {}
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 767px) {
  .container {
    max-width: 1280px;
    height: auto;
    background: #ffffff;
    margin: 16px auto;
    padding: 60px 84px;

    .title {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      text-align: center;
      margin-bottom: 35px;
    }

    .cancel {
      margin-top: 90px !important;
      margin: 0px auto;
      width: 193px;
      height: 49px;
      background: #e60012;
      border-radius: 4px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 49px;
      text-align: center;
      cursor: pointer;
    }
  }
}

@media (max-width: 767px) {
  .container {
    padding: 30px 16px;
    background: #ffffff;
    margin: 0 auto;

    .title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 800;
      color: #333333;
      line-height: 8px;
      text-align: center;
      margin-bottom: 35px;
    }

    .cancel {
      display: none;
    }
  }
}
</style>
